import Vue from 'vue'
import Vuex from 'vuex'
import uploadService from '../api/upload'

Vue.use(Vuex)

const initialState = {
}

const getters = {
}

export const actions = {
  async uploadUserProfileImage(contex, payload) {
    try {
      const response = await uploadService.uploadUserProfileImage(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async uploadDeceasedProfileImage(contex, payload) {
    try {
      const response = await uploadService.uploadDeceasedProfileImage(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async uploadDeceasedImages(contex, payload) {
    try {
      const response = await uploadService.uploadDeceasedImages(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async uploadDeceasedVideos(contex, payload) {
    try {
      const response = await uploadService.uploadDeceasedVideos(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async uploadDeceasedDocuments(contex, payload) {
    try {
      const response = await uploadService.uploadDeceasedDocuments(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async uploadDeceasedSuggestionImages(contex, payload) {
    try {
      const response = await uploadService.uploadDeceasedSuggestionImages(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
  async uploadDeceasedStory(contex, payload) {
    try {
      const response = await uploadService.uploadDeceasedStory(payload);
      contex.commit('toast', { message: contex.rootState.langObj.response.success.uploaded, color: 'black' }, { root: true })
      return Promise.resolve(response);
    } catch (error) {
      contex.commit('toast', { message: contex.rootState.langObj.response.error.somethingWentWrong, color: 'red lighten-2' }, { root: true })
      return Promise.reject(error);
    }
  },
}

export const state = { ...initialState }

export default {
  state,
  getters,
  actions
}
